import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';

interface PostLoginRedirectProps {
  children: React.ReactNode;
}

export const PostLoginRedirect: React.FC<PostLoginRedirectProps> = ({ children }) => {
  const { accounts } = useMsal();
  const navigate = useNavigate();
  const [hasRedirected, setHasRedirected] = React.useState(false);

  useEffect(() => {
    // Check if we just logged in and have a return path
    if (accounts.length > 0 && !hasRedirected) {
      const returnPath = sessionStorage.getItem('loginReturnPath');
      if (returnPath) {
        sessionStorage.removeItem('loginReturnPath');
        setHasRedirected(true);
        navigate(returnPath);
      }
    }
  }, [accounts, navigate, hasRedirected]);

  return <>{children}</>;
};